<script setup lang="ts">
/**
 * Modal dialog: centered on larger screens, a bottom sheet on phones.
 * Focus is trapped and restored, Esc and the backdrop close it (Reka UI).
 */
import {
  DialogContent,
  DialogDescription,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
} from 'reka-ui';

const open = defineModel<boolean>('open', { required: true });
defineProps<{ title: string; description?: string }>();
</script>

<template>
  <DialogRoot v-model:open="open">
    <DialogPortal>
      <DialogOverlay class="dialog-overlay" />
      <DialogContent class="dialog" :aria-describedby="description ? undefined : ''">
        <header class="dialog__header">
          <DialogTitle class="dialog__title">{{ title }}</DialogTitle>
          <DialogDescription v-if="description" class="muted">{{ description }}</DialogDescription>
        </header>
        <slot />
      </DialogContent>
    </DialogPortal>
  </DialogRoot>
</template>
